// extracted by mini-css-extract-plugin
export var wrapperStyle = "section_about_what_we_do-module--wrapperStyle---jn6j";